<template>
  <div>
    <el-card class="mb20" shadow="hover">
      <el-row type="flex" :gutter="20" align="middle">
        <el-col :xs="12" :sm="10" :md="8" :lg="5">
          <el-input
            :placeholder="$t('search')"
            clearable
            v-model="filter.search"
            @keyup.enter.native="get_list"
          ></el-input>
        </el-col>
        <el-col :xs="12" :sm="10" :md="8" :lg="5">
          <el-button @click="get_list" type="primary">{{$t('search_zh')}}</el-button>
          <el-button @click="reset" type="info">{{$t('btnTip.reset')}}</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card>
      <div class="flexBC mb20">
        <el-button
          type="primary"
          @click="handleClick('add')"
        >{{$t('btnTip').add}}</el-button>
         <el-button
          type="primary"
          @click="outExe"
          >{{$t('outExe')}}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{padding: '6px 0'}"
        :headerCellStyle="{background:'rgba(51, 55, 68, 1)',color:'#fff'}"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      > 
       <template v-slot:answer="slotProps">
            <div class="mutiple" v-html="slotProps.callback.row.answer"></div>
        </template>
        <template v-slot:active="slotProps">
            <el-tag :type="activeTag(slotProps.callback.row.active)">{{active(slotProps.callback.row.active)}}</el-tag>
        </template>
        <template v-slot:operation="slotProps">
          <el-tooltip class="item" effect="dark" :content="$t('btnTip').edit" placement="top">
            <el-button
              @click="handleClick('edit',slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="slotProps.callback.row.active === 0
                ? $t('FAQ.active1')
                : $t('FAQ.active0')" placement="top">
            <el-button
              @click="handleClick('active',slotProps.callback.row)"
              :type="slotProps.callback.row.active === 0 ? 'success' : 'warning'"
              size="mini"
            >{{
                slotProps.callback.row.active === 0
                  ? $t("FAQ.active1")
                  : $t("FAQ.active0")
              }}</el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('btnTip').delete" placement="top">
            <el-button
              @click="remove(slotProps.callback.row.id)"
              icon="el-icon-delete"
              type="danger"
              size="mini"
            ></el-button>
          </el-tooltip>
        </template>
      </my-table>
      <page :total="list_data.total" :page_size.sync="pageSize" :page.sync="page" />
    </el-card>
  </div>
</template>

<script>
import { mixin_list } from "@/mixins";
import myTable from '@/components/table'
import page from "@/components/page";
import { getFAQ, deleteFAQ, editFAQ } from '@/api/api';
export default {
  mixins: [ mixin_list(getFAQ)],
  components: {
    page,
    myTable
  },
  data () {
    return {
      filter: {
        search: ''
      },
      columns: [
        {
          label: 'ID',
          prop: 'id',
          sortable:true,
          width:80
        }, 
         {
          label: this.$t('FAQ.tag'),
          prop: 'tag',
          sortable:true,
        },
        {
          label: this.$t('FAQ.question'),
          prop: 'question',
          sortable:true
        },
        {
          label: this.$t('FAQ.answer'),
          prop: 'answer',
          slot:'answer',
          sortable:true
        },
        {
          label: this.$t('FAQ.order'),
          prop: 'order',
          sortable:true
        },
        {
          label: this.$t('FAQ.active'),
          prop: 'active',
          slot:'active',
          sortable:true
        },
        {
          label: this.$t('operation'),
          prop: '',
          width: 300,
          slot: 'operation'
        }],
    }
  },
  methods: {
      active(active){
          switch(active){
              case 0:
                  return this.$t('FAQ.active0')
                case 1:
                  return this.$t('FAQ.active1')
          }
      },
      activeTag(activeTag){
        switch(activeTag){
          case 0:
            return 'info'
          case 1:
            return 'success'
        }
      },
    async handleClick (value, item) {
      switch (value) {
        case 'add':
          this.$router.push(`/serviceCenter/FAQ/edit`)
          break;
        case 'active':
            await editFAQ({...item,active:item.active===0?1:0})
            this.get_list()
            break;
        case 'edit':
          this.$router.push(`/serviceCenter/FAQ/edit?id=${item.id}`)
          break;
      }
    },
    remove (id) {
      this.$confirm(this.$t('FAQ.sureDeleteFAQ'), this.$t('tips'), {
        confirmButtonText: this.$t('btnTip.submit'),
        cancelButtonText: this.$t('btnTip.cancel'),
        type: 'warning'
      }).then(async () => {
        const res = await deleteFAQ(id)
        this.get_list()
      }).catch(() => {
      })
    },
  }
}
</script>
<style lang="scss" scoped>
</style>